/* ============================================================
   SPARTAN VITA — theme.js
   JS vanilla para funcionalidad que vive fuera de Alpine.js
   ============================================================ */

/* --- Lazy loading de imágenes --- */
if ('IntersectionObserver' in window) {
  const imgObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
        imgObserver.unobserve(img);
      }
    });
  }, { rootMargin: '200px' });

  document.querySelectorAll('img[data-src]').forEach(img => imgObserver.observe(img));
}

/* --- Scroll reveal para secciones --- */
if ('IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('sv-revealed');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('[data-reveal]').forEach(el => revealObserver.observe(el));
}

/* --- Sticky header con shadow al hacer scroll --- */
(function() {
  const header = document.getElementById('sv-header');
  if (!header) return;

  let lastScroll = 0;
  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    if (currentScroll > 80) {
      header.classList.add('sv-header--scrolled');
    } else {
      header.classList.remove('sv-header--scrolled');
    }
    lastScroll = currentScroll;
  }, { passive: true });
})();

/* --- Formato de dinero COP (disponible globalmente) --- */
window.svFormatMoney = function(cents) {
  return new Intl.NumberFormat('es-CO', {
    style:                 'currency',
    currency:              'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(cents / 100);
};

/* --- Dispatch helpers para comunicación con Alpine --- */
window.svOpenCart    = () => document.dispatchEvent(new CustomEvent('cart:open'));
window.svAddToCart   = (variantId, qty = 1) =>
  document.dispatchEvent(new CustomEvent('cart:add', { detail: { variantId, qty } }));
